import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=e7ff517c&scoped=true&functional=true"
var script = {}
import style0 from "./simple.vue?vue&type=style&index=0&id=e7ff517c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e7ff517c",
  null
  
)

export default component.exports